import type { VNode } from "preact";
import logo from "../assets/images/abolitionist-logo.svg";

interface HeaderProps {
  className?: string;
}

export function Header({ className = "" }: HeaderProps): VNode {
  return (
    <header
      className={`h-[80px] w-full flex-shrink-0 px-5 sm:px-10 py-[20px] flex items-center justify-start bg-ap-mustard ${className}`}
    >
      <img
        src={logo}
        alt="Abolitionist Place"
        className="h-[52px] w-auto"
      />
    </header>
  );
}
